import { create } from "../../../../../common/utils/zustand_state_manager";

type State = {
  IdObra: number;
  Fornecedor: string | null;
  TipoBloco: string | null;
  NroNotaFiscal: string | null;
  dataReceberDe: Date | null,
  dataReceberAte: Date | null,
};


type Action = {
  setFilters: (filters: Partial<State>) => void;
  clearFilters: () => void;
};


export const initialFiltersValues: State = {
  IdObra: 0,
  Fornecedor: "",
  NroNotaFiscal: "",
  TipoBloco: "",
  dataReceberDe: null,
  dataReceberAte: null,
};

export const useAlvenariaEstrututalFilters = create<State & Action>((set) => ({
  ...initialFiltersValues,

  setFilters: (filters) => set((state) => ({ ...state, ...filters })),

  clearFilters: () => set(initialFiltersValues),
}));